import {Injectable} from '@angular/core';
import {HttpErrorResponse} from "@angular/common/http";
import {TranslateService} from "@ngx-translate/core";
import {environment} from "../../../environments/local/environment";
import {ERROR_CODES} from "../../model/codes";

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(private translateService: TranslateService) {
  }

  getClientMessage(error: Error): string {
    if (!navigator.onLine) {
      return this.translateService.instant('ERRORS.NO_INTERNET');
    }
    if (environment.production) {
      return '';
      // return this.translateService.instant('ERRORS.UNEXPECTED_CLIENT_ERROR')
    }
    return error.message ? error.message : error.toString();
  }

  getClientStack(error: Error): string | undefined {
    return error.stack;
  }

  getServerMessage(error: HttpErrorResponse): string | null {
    return this.generateHttpResponseErrorMessage(error);
  }

  getServerStack(error: HttpErrorResponse): string {
    // handle stack trace
    return 'stack';
  }

  generateHttpResponseErrorMessage(err: HttpErrorResponse): string | null {
    let errorMessage: string | null = '';
    if (err.status) {
      switch (err.status) {
        case 400:
          if (err.error?.code) {
            errorMessage = this.handle400Errors(err);
          }
          break;
        case 401:
          errorMessage = this.translateService.instant('ERRORS.NO_PERMISSION');
          break;
        case 403:
          errorMessage = this.translateService.instant('ERRORS.NO_PERMISSION');
          break;
        case 413:
          errorMessage = this.translateService.instant('ERRORS.REQUEST_TOO_LARGE');
          break;
        case 500:
          errorMessage = this.translateService.instant('ERRORS.INTERNAL_SERVER_ERROR');
          break;
        case 503:
          errorMessage = this.translateService.instant('ERRORS.PERSISTENCE_NOT_AVAILABLE');
          break;
      }
    }
    if (!errorMessage) {
      errorMessage = this.translateService.instant('ERRORS.UNEXPECTED_ERROR');
    }
    return errorMessage;
  }

  createUnknownCodeMessage(error: HttpErrorResponse): string {
    let message = this.translateService.instant('ERRORS.UNEXPECTED_ERROR');
    let code = "";
    if (error.status) {
      code = "Code: ";
      if (error.status === 400 && error.error?.errorCode) {
        code = code + error.error.errorCode;
      } else {
        code = code + error.status;
      }
      message = message + ' ' + code;
    }
    return message;
  }

  private handle400Errors(err: HttpErrorResponse): string {
    let errorMessage = '';
    switch (err.error.code) {
      case ERROR_CODES.CONVERSATION_NOT_FOUND:
        errorMessage = this.translateService.instant('ERRORS.CONVERSATION_NOT_FOUND');
        break;
      case ERROR_CODES.MESSAGE_NOT_FOUND:
        errorMessage = this.translateService.instant('ERRORS.MESSAGE_NOT_FOUND');
        break;
      case ERROR_CODES.IMAGE_NOT_FOUND:
        errorMessage = this.translateService.instant('ERRORS.IMAGE_NOT_FOUND');
        break;
      case ERROR_CODES.VIDEO_NOT_FOUND:
        errorMessage = this.translateService.instant('ERRORS.VIDEO_NOT_FOUND');
        break;
      case ERROR_CODES.DOCUMENT_NOT_FOUND:
        errorMessage = this.translateService.instant('ERRORS.DOCUMENT_NOT_FOUND');
        break;
      default:
        errorMessage = this.createUnknownCodeMessage(err);
        break;
    }
    return errorMessage;
  }
}
